import { z } from 'zod'

export const COACHING_SHELL_SESSION_CONTRACT_VERSION = '1.0.0' as const
/** Session mutation envelopes explicitly retain replay state for idempotent clients. */
export const coachingShellSessionResponseSchema = z.object({
  contract_version: z.literal(COACHING_SHELL_SESSION_CONTRACT_VERSION).or(z.string().min(1)),
  replayed: z.boolean().optional(),
}).passthrough()
export type CoachingShellSessionResponse = z.infer<typeof coachingShellSessionResponseSchema>
